import { useEffect } from "react"

import { usePublicPartnerRetrieve } from "@boundless/bl-api-client/public/services"
import { Outlet } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import { AccountLayout } from "@/components/account/layout/AccountLayout"
import { store } from "@/lib/store"
import { isEmbed } from "@/lib/utils"

export const Route = createFileRoute("/(public)/p/$slug")({
  component: RouteComponent,
})

export function RouteComponent() {
  // TODO: fix by integrating embed landing page in the router structure
  // This is temporary a workaround to prevent rendering this route
  // when it's being used in an embed context.
  // If user has partner instance (partnerSlug) in DashboardView
  // on logout will redirect to partner branded login page.
  if (isEmbed()) {
    return null
  }

  const { slug } = Route.useParams()
  const { data: theme } = usePublicPartnerRetrieve(slug)

  useEffect(() => {
    store.setState({
      partnerLogo: theme?.logo,
      primaryColor: theme?.primaryColor,
      headerGradientColor: theme?.headerGradientColor ?? null,
      accentColor: theme?.accentColor ?? null,
    })
  }, [
    theme?.logo,
    theme?.primaryColor,
    theme?.headerGradientColor,
    theme?.accentColor,
  ])

  return (
    <AccountLayout>
      <Outlet />
    </AccountLayout>
  )
}
